<template>
  <div class="p-home">
    <div class="p-home__inner">
      <div class="c-head" ref="head">
        <TopTabbar ref="tabbar" :tabList="tabListShow" @tabClick="tabClick" />
      </div>
      <div class="c-home-info" ref="home">
        <img src="../../assets/home/banner-2.png" class="c-banner" />
        <div class="c-home-info__text-box">
          <div class="c-home-info__text--1">义乌市仓选网络科技有限公司</div>
          <div class="c-home-info__text--2">以创新科技，连接无限可能</div>
        </div>
      </div>
      <!-- 公司简介 -->
      <div class="c-profile" ref="profile">
        <div class="c-profile__inner">
          <div style="flex-grow: 1">
            <div class="p-home__text--1">COMPANT PROFILE</div>
            <div class="p-home__text--2">公司简介</div>
            <div class="p-home__text--3 c-profile__content">
              我们是一家以技术创新为引擎、以资源整合为纽带的新型科技服务企业。自创立以来，始终深耕网络技术服务与数字化解决方案领域，通过持续的技术研发与跨行业实践，构建了涵盖技术服务、软件开发、系统集成及供应链支持的综合服务体系。我们秉承“技术赋能商业，服务创造价值”的核心理念，致力于成为企业在数字经济时代最可信赖的战略合作伙伴。
            </div>
          </div>
          <img
            src="../../assets/home/compant-profile.png"
            class="c-profile__image"
          />
          <!-- <div class="c-profile__box">
            <div class="box-item box-line">
              <div>
                <div>
                  <span class="box-item__value">50</span>
                  <span class="box-item__unit">家</span>
                </div>
                <div class="box-item__name">合作公司</div>
              </div>
            </div>
            <div class="box-item box-line">
              <div>
                <div>
                  <span class="box-item__value">120</span>
                  <span class="box-item__unit">人</span>
                </div>
                <div class="box-item__name">员工人数</div>
              </div>
            </div>
            <div class="box-item">
              <div>
                <div>
                  <span class="box-item__value">1500</span>
                  <span class="box-item__unit">㎡</span>
                </div>
                <div class="box-item__name">办公场地</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- 业务版图 -->
      <div class="c-investment" ref="investment">
        <div>
          <div class="p-home__text--1">INVESTMENT FIELD</div>
          <div class="p-home__text--2">业务版图</div>
          <div class="c-investment__box">
            <div
              class="c-investment__item"
              v-for="(field, index) in invField"
              :key="index"
            >
              <div class="c-inv-field">
                <div
                  class="c-inv-field__bg"
                  :class="'c-inv-field__bg--' + (index + 1)"
                ></div>
                <div class="c-inv-field__mask">
                  <div class="c-inv-field__text">{{ field.title1 }}</div>
                  <div class="c-inv-field__text c-inv-field__space">-</div>
                  <div class="c-inv-field__text">{{ field.title2 }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻资讯 -->
      <div class="c-news-info" ref="news" v-show="false">
        <div class="c-news-info__inner">
          <div class="p-home__text--1">NEWS AND INFORMATION</div>
          <div
            class="p-home__text--2"
            style="display: flex; justify-content: space-between"
          >
            新闻资讯
            <div class="p-home__text--1">MORE</div>
          </div>
          <div class="c-news-info__list">
            <div
              class="c-news-info__item"
              v-for="(item, index) in news"
              :key="index"
            >
              <div class="c-news-info__title">
                <div class="c-news-info__text--1">{{ item.date }}</div>
                <div class="c-news-info__text--2">
                  {{ item.title }}
                </div>
              </div>
              <div class="c-news-info__content">
                <div class="c-news-info__text--3">{{ item.year }}</div>
                <div class="c-news-info__text--4">
                  {{ item.content }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div class="c-partner" ref="partner" v-show="false">
        <div class="c-partner__inner">
          <div class="p-home__text--1">COOPERATIVE PARTNER</div>
          <div class="p-home__text--2">合作伙伴</div>
          <div class="c-partner__list">
            <div class="c-partner__item" v-for="i in 10" :key="i">
              <div
                class="c-partner__logo"
                :class="'c-partner__logo--' + i"
              ></div>
              <!-- <img src="../../assets/home/partner-logo-1.png"> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="c-foot" ref="us">
        <div class="c-foot__inner">
          <div class="c-foot__contact-us">
            <div class="c-foot__text--1">CONTACT US</div>
            <!-- <div class="c-foot__text--2">联系我们</div> -->
            <!-- <div class="c-foot__text--3">400-033-2025</div> -->
            <div class="c-foot__text--1">联系我们</div>
          </div>
          <div
            :class="'c-foot__info-box--' + (index + 1)"
            v-for="(us, index) in usInfo"
            :key="index"
            v-show="![0, 2].includes(index)"
          >
            <div class="c-foot__text--4">{{ us.title }}</div>
            <div class="c-foot__text--4">{{ us.content }}</div>
          </div>
        </div>
      </div>
      <!-- 备案 -->
      <div class="c-beian">
        <div class="c-beian__text--1">备案号：</div>
        <div class="c-beian__text--2" @click="toBeiAn">浙ICP备2025214892号-1</div>
      </div>
    </div>
  </div>
</template>
<script>
import TopTabbar from "../TopTabbar/TopTabbar.vue";
export default {
  name: "QuWanHome",
  components: {
    TopTabbar,
  },
  data() {
    return {
      tabList: [
        { name: "首页", key: "home" },
        { name: "关于我们", key: "profile" },
        { name: "业务版图", key: "investment" },
        { name: "新闻资讯", key: "news" },
        { name: "合作伙伴", key: "partner" },
        { name: "联系我们", key: "us" },
      ],
      invField: [
        { title1: "信息技术咨询服务", title2: "Information\nTechnology" },
        { title1: "数字化营销服务", title2: "Digital\nmarketing" },
        { title1: "知识产权服务", title2: "intellectual\nproperty" },
        { title1: "其他技术服务", title2: "Other" },
      ],
      news: [
        {
          year: "2024",
          date: "12/11",
          title: "关于开展“迎新年购房安家活动”的倡议",
          content:
            "为贯彻落实中央经济工作会议精神，持续用力推动房地产市场止跌回稳，根据全国住房城乡建设工作会议精神，中国房地产业协会向全行业发出开展“迎新年购房安家活动”…",
        },
        {
          year: "2024",
          date: "10/03",
          title: "关于《智能家居技术应用标准》征求意见的函",
          content:
            "为根据中国房地产业协会《关于中国房地产业协会标准<智能家居技术应用>立项的通知》（中国房协〔2024〕51号）文件要求，由中国房地产业协会内装家居分会（原内装…",
        },
        {
          year: "2024",
          date: "4/12",
          title: "关于举办中国房地产业协会专题讲座（第四十期）的通知",
          content:
            "帮助会员单位回顾全年房地产市场形势，了解行业面临的问题，研判明年政策趋势、市场走势，定于2024年12月31日在线上举办中国房地产业协会专题讲座（第四十期）。现…",
        },
        {
          year: "2024",
          date: "1/23",
          title: "关于开展商务写字楼等级评价工作的通知",
          content:
            "为提高商务写字楼管理运营水平，提升资产价值和市场竞争力，发挥楼宇经济优势项目的示范带动和引领作用。中国房地产业协会决定依据《商务写字楼评价标准》（T/CECS…",
        },
      ],
      usInfo: [
        { title: "工作时间", content: "周一至周五 8:30-17:30" },
        { title: "电子邮箱", content: "liudengshan@quplay.cn" },
        { title: "技术支持", content: "浙江海浪软件开发有限公司" },
        {
          title: "地址",
          content:
            "浙江省金华市义乌市北苑街道\n春盛小区30幢1单元205",
        },
      ],
    };
  },
  computed: {
    tabListShow() {
      return this.tabList.map((i) => i.name);
    },
  },
  methods: {
    tabClick(i) {
      this.isScrolling = true;
      const e = this.$refs[this.tabList[i].key];
      const head = this.$refs["head"];
      this.scrollToY(e.offsetTop - head.offsetHeight, 500);
      setTimeout(() => {
        this.isScrolling = false;
      }, 550);
    },
    scrollToY(y, duration = 0, element = document.scrollingElement) {
      // cancel if already on target position
      if (element.scrollTop === y) {
        return;
      }

      const NUMBER_TWO = 2;
      const cosParameter = (element.scrollTop - y) / NUMBER_TWO;
      let scrollCount = 0;
      let oldTimestamp = null;

      const step = function (newTimestamp) {
        if (oldTimestamp !== null) {
          // if duration is 0 scrollCount will be Infinity
          scrollCount += (Math.PI * (newTimestamp - oldTimestamp)) / duration;
          if (scrollCount >= Math.PI) {
            element.scrollTop = y;
            return;
          }
          element.scrollTop =
            cosParameter + y + cosParameter * Math.cos(scrollCount);
        }
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    },
    toBeiAn() {
      // window.location.href = "https://beian.miit.gov.cn/#/Integrated/index"
      window.open("https://beian.miit.gov.cn/#/Integrated/index", "_blank")
    }
  },
  mounted() {
    if (this.$refs.tabbar.tabListSelectIndex === -1) {
      this.$refs.tabbar.tabListSelectIndex = 0;
    }
    window.addEventListener("scroll", () => {
      if (this.isScrolling) return;
      // 当前的滚动距离
      const scrollTop = Math.ceil(
        window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
      );
      const { tabbar, profile, investment, news, partner, us, head } =
        this.$refs;
      if (scrollTop < profile.offsetTop - head.offsetHeight) {
        tabbar.tabListSelectIndex = 0;
      } else if (
        scrollTop >= profile.offsetTop - head.offsetHeight &&
        scrollTop < investment.offsetTop - head.offsetHeight
      ) {
        tabbar.tabListSelectIndex = 1;
      } else if (
        scrollTop >= investment.offsetTop - head.offsetHeight &&
        scrollTop < news.offsetTop - head.offsetHeight
      ) {
        tabbar.tabListSelectIndex = 2;
      } else if (
        scrollTop >= news.offsetTop - head.offsetHeight &&
        scrollTop < partner.offsetTop - head.offsetHeight
      ) {
        tabbar.tabListSelectIndex = 3;
      } else if (
        scrollTop >= partner.offsetTop - head.offsetHeight &&
        scrollTop < us.offsetTop - head.offsetHeight
      ) {
        tabbar.tabListSelectIndex = 4;
      } else if (scrollTop >= us.offsetTop - head.offsetHeight) {
        tabbar.tabListSelectIndex = 5;
      }
    });
  },
};
</script>
<style scoped>
/* 首页 */
/* #region */
.p-home {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.p-home div,
.p-home span {
  caret-color: transparent;
}
.p-home__inner {
  width: 1920px;
}
.p-home__text--1 {
  color: #000000;
  font-family: Source Han Sans CN;
  font-size: 32px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 2px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.p-home__text--2 {
  color: #000000;
  font-family: Source Han Sans CN;
  font-size: 32px;
  font-weight: 500;
  line-height: 32px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  margin-top: 26px;
}
.p-home__text--3 {
  color: #000000;
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-head {
  position: sticky;
  top: 0;
  z-index: 10;
}
/* #endregion */

/* 头图 */
.c-banner {
  width: 1920px;
  height: 792px;
}

/* 公司简介 */
/* #region */
.c-profile {
  width: 100%;
  background-color: #ffffff;
  padding: 120px 0 169px;
  display: flex;
  justify-content: center;
}
.c-profile__inner {
  width: 1200px;
  display: flex;
  position: relative;
}
.c-profile__image {
  /* width: 526px; */
  /* height: 541px; */
  width: 292px;
  height: 300px;
  flex-shrink: 0;
}
.c-profile__content {
  width: 576px;
  margin-top: 58px;
}
.c-profile__box {
  width: 800px;
  height: 140px;
  background-color: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 14.2px 0px #0000001a;
  position: absolute;
  top: 345px;
  left: 0;
  display: flex;
}
.c-profile__box .box-item {
  width: 0;
  flex-grow: 1;
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 90px;
}
.c-profile__box .box-line::after {
  content: "";
  width: 1px;
  background-color: #eaeaea;
  position: absolute;
  top: 32px;
  right: 0;
  bottom: 30px;
}
.c-profile__box .box-item__value {
  color: #0060aa;
  font-family: Source Han Sans CN;
  font-size: 48px;
  font-weight: 500;
  line-height: 48px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-profile__box .box-item__unit {
  color: #979caa;
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  margin-left: 8px;
}
.c-profile__box .box-item__name {
  color: #000000;
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  margin-top: 20px;
}
/* #endregion */

/* 业务版图 */
/* #region */
.c-investment {
  width: 100%;
  background-color: #f7f7f7;
  padding: 112px 0 134px;
  display: flex;
  justify-content: center;
}
.c-investment__box {
  width: 1200px;
  padding-top: 80px;
  display: flex;
  justify-content: space-between;
}
.c-investment__item {
  width: 274px;
  height: 424px;
  flex-shrink: 0;
  overflow: hidden;
}

.c-inv-field {
  width: 100%;
  height: 100%;
  position: relative;
}
.c-inv-field:hover .c-inv-field__bg {
  transform: scale(1.2);
  transition-duration: 0.3s;
}
.c-inv-field__text {
  white-space: pre-wrap;

  color: #ffffff;
  font-family: Source Han Sans CN;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-transform: uppercase;
}
.c-inv-field__space {
  margin-top: 33px;
}
.c-inv-field .c-inv-field__bg--1 {
  width: 100%;
  height: 100%;
  background-image: url(../../assets/home/inv-field-1.png);
  background-repeat: no-repeat;
}
.c-inv-field .c-inv-field__bg--2 {
  width: 100%;
  height: 100%;
  background-image: url(../../assets/home/inv-field-2.png);
  background-repeat: no-repeat;
}
.c-inv-field .c-inv-field__bg--3 {
  width: 100%;
  height: 100%;
  background-image: url(../../assets/home/inv-field-3.png);
  background-repeat: no-repeat;
}
.c-inv-field .c-inv-field__bg--4 {
  width: 100%;
  height: 100%;
  background-image: url(../../assets/home/inv-field-4.png);
  background-repeat: no-repeat;
}
.c-inv-field__mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 30px 24px;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
/* #endregion */

/* 新闻资讯 */
/* #region */
.c-news-info {
  width: 100%;
  background-color: #ffffff;
  padding: 130px 0 147px;
  display: flex;
  justify-content: center;
}
.c-news-info__inner {
  width: 1200px;
}
.c-news-info__list {
  width: 100%;
  padding-top: 19px;
  display: flex;
  flex-wrap: wrap;
}
.c-news-info__item {
  width: 578px;
  flex-grow: 1;
  margin: 68px 44px 0 0;
}
.c-news-info__item:nth-child(2n) {
  margin-right: 0;
}
.c-news-info__title {
  display: flex;
  align-items: center;
}
.c-news-info__content {
  display: flex;
  margin-top: 5px;
}
.c-news-info__text--1 {
  width: 100px;
  flex-shrink: 0;

  color: #000000;
  font-family: Source Han Sans CN;
  font-size: 28px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-news-info__text--2 {
  color: #000000;
  font-family: Source Han Sans CN;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-news-info__text--3 {
  width: 100px;
  flex-shrink: 0;

  color: #979caa;
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-news-info__text--4 {
  color: #000000;
  font-family: Source Han Sans CN;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  display: -webkit-box; /* 创建弹性盒子布局 */
  -webkit-box-orient: vertical; /* 设置盒子的垂直布局 */
  overflow: hidden; /* 隐藏超出元素高度的文本 */
  text-overflow: ellipsis; /* 使用省略号表示文本溢出 */
  -webkit-line-clamp: 2; /* 限制文本显示的最大行数 */
}
/* #endregion */

/* 合作伙伴 */
/* #region */
.c-partner {
  width: 100%;
  background-color: #f7f7f7;
  padding: 111px 0 105px;
  display: flex;
  justify-content: center;
}
.c-partner__inner {
  width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.c-partner__list {
  width: 100%;
  padding-top: 70px;
  display: flex;
  flex-wrap: wrap;
}
.c-partner__item {
  width: 220px;
  height: 128px;
  background-color: #ffffff;
  flex-shrink: 0;
  margin: 0 25px 38px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-partner__item:nth-child(5n) {
  margin-right: 0;
}
.c-partner__logo {
  width: 84px;
  height: 84px;
  flex-shrink: 0;
}
.c-partner__logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.c-partner__logo.c-partner__logo--1 {
  background-image: url("../../assets/home/partner-logo-1.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--2 {
  background-image: url("../../assets/home/partner-logo-2.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--3 {
  background-image: url("../../assets/home/partner-logo-3.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--4 {
  background-image: url("../../assets/home/partner-logo-4.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--5 {
  background-image: url("../../assets/home/partner-logo-5.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--6 {
  background-image: url("../../assets/home/partner-logo-6.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--7 {
  background-image: url("../../assets/home/partner-logo-7.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--8 {
  background-image: url("../../assets/home/partner-logo-8.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--9 {
  background-image: url("../../assets/home/partner-logo-9.png");
  background-repeat: no-repeat;
  background-position: center center;
}
.c-partner__logo.c-partner__logo--10 {
  background-image: url("../../assets/home/partner-logo-10.png");
  background-repeat: no-repeat;
  background-position: center center;
}
/* #endregion */

/* 联系我们 */
/* #region */
.c-foot {
  width: 100%;
  background-color: #292e3a;
  padding: 127px 0 116px;
  display: flex;
  justify-content: center;
}
.c-foot__inner {
  width: 1203px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.c-foot__contact-us {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.c-foot__text--1 {
  padding-bottom: 55px;

  color: #ffffff;
  font-family: Source Han Sans CN;
  font-size: 36px;
  font-weight: 500;
  line-height: 36px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-foot__text--2 {
  color: #ffffff;
  font-family: Source Han Sans CN;
  font-size: 16px;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-foot__text--3 {
  margin-top: 20px;

  color: #018bff;
  font-family: Source Han Sans CN;
  font-size: 36px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-foot__text--4 {
  white-space: pre-wrap;
  margin-top: 16px;

  color: #ffffff;
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-foot__text--4:first-child {
  margin-top: 0;
}
.c-foot__info-box--1 {
  position: absolute;
  top: 0;
  left: 639px;
}
.c-foot__info-box--2 {
  position: absolute;
  top: 0;
  left: 887px;
}
.c-foot__info-box--3 {
  position: absolute;
  top: 104px;
  left: 639px;
}
.c-foot__info-box--4 {
  position: absolute;
  top: 104px;
  left: 887px;
}
/* #endregion */



.c-home-info {
  position: relative;
}
.c-home-info__text-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.c-home-info__text--1 {
  font-family: "Source Han Sans SC";
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: 2px;
  color: #fff;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-home-info__text--2 {
  margin-top: 36px;
  font-family: "Source Han Sans SC";
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
  color: #fff;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.c-beian {
  background-color: #292e3a;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-beian__text--1 {
  color: #ffffff;
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.c-beian__text--2 {
  cursor: pointer;
  color: #ffffff;
  font-family: Source Han Sans CN;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
</style>